<template>
  <v-dialog
    v-model="getModalListarLancamentoCaixa"
    fullscreen
    persistent
    max-width="720px"
  >
    <v-card outlined>
      <v-card-title>
        Lançamentos de Caixa
        <v-spacer></v-spacer>
        <v-btn icon @click="setModalListarLancamentoCaixa(false)" float-right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-title>
        <v-btn
          color="default"
          @click="setModalListarLancamentoCaixa(false)"
          outlined
          >Voltar</v-btn
        >
        <v-btn
          color="primary"
          class="ml-2"
          @click="cadastrarLancamentoCaixa"
          v-if="$helper.verificaPermissao('cadastrar-lancamento-caixa')"
          outlined
          >Cadastro</v-btn
        >

        <v-btn
          class="ml-2"
          color="warning"
          outlined
          @click="setModalRelatorioFechamentoCaixa(true)"
          v-if="$helper.verificaPermissao('imprimir-fechamento-caixa')"
          >Imprimir Fechamento</v-btn
        >

        <v-spacer></v-spacer>
        <h3>Registros: {{ getLancamentosCaixa.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getLancamentosCaixa.current_page"
          :length="getLancamentosCaixa.last_page"
          @input="listarLancamentoCaixa({ ...dataPagina, page: $event })"
        ></v-pagination>
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="8%">
                  <v-text-field
                    v-model="dataPagina.id"
                    outlined
                    dense
                    label="Cód."
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th>
                  <v-select
                    :items="getLancamentoCaixaTipos"
                    v-model="dataPagina.tipo"
                    label="Tipo"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-select>
                </th>
                <th width="10%">Valor</th>

                <th>
                  <v-autocomplete
                    :items="getFuncionarios"
                    item-value="id"
                    item-text="nome_abreviado"
                    v-model="dataPagina.funcionarioId"
                    label="Funcionário"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-autocomplete>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.data"
                    label="Data"
                    id="id"
                    outlined
                    dense
                    type="date"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="8%">
                <v-autocomplete
                    outlined
                    label="Exibir"
                    dense
                    :items="[10, 20, 30, 40, 50]"
                    item-value="value"
                    item-text="label"
                    v-model="dataPagina.limit"
                    @change="debouncedPesquisar({ ...dataPagina })"
                    class="mt-2"
                  ></v-autocomplete></th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="l in getLancamentosCaixa.data" :key="l.id">
              <td align="center">{{l.id}}</td>
              <td>{{l.tipo}}</td>
              <td>{{$helper.formatReal(parseFloat(l.valor))}}</td>
              <td>{{l.funcionario.nome_abreviado}}</td>
              <td>{{$helper.formatDateTime(l.created_at)}}</td>
              <td align="center">
              <TooltipButton
                    @click.native="visualizarLancamentoCaixa(l)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="
                      $helper.verificaPermissao(
                        'visualizar-lancamento-caixa'
                      )
                    "
                  />
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <ModalCadastro />
    <ModalRelatorioFechamentoCaixa />
  </v-dialog>
</template>

<script>
import ModalRelatorioFechamentoCaixa from "@/pages/caixa/ModalRelatorioFechamento";

import ModalCadastro from "@/pages/caixa/lancamento/ModalCadastro";
import { mapGetters, mapActions } from "vuex";
var _ = require("lodash");

export default {
  components: {
    ModalCadastro,
    ModalRelatorioFechamentoCaixa,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "#", value: "id", sortable: false },
        { text: "Tipo", align: "left", sortable: false, value: "tipo" },
        {
          text: "Funcionário",
          align: "left",
          sortable: false,
          value: "funcionario.nome_abreviado",
        },
        { text: "Valor", align: "left", sortable: false, value: "_valor" },
        { text: "Data", align: "left", sortable: false, value: "_data" },
        { text: "Ações", value: "action", sortable: false },
      ],
      funcionarios: [],
      dataPagina: {
        id: "",
        tipo: "",
        funcionarioId: "",
        data: "",
        page: "",
        limit: 20,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getLancamentosCaixa",
      "getModalCadastroLancamentoCaixa",
      "getModalListarLancamentoCaixa",
      "getLancamentoCaixaTipos",
      "getFuncionarios",
    ]),
  },
  methods: {
    ...mapActions([
      "listarLancamentoCaixa",
      "visualizarLancamentoCaixa",
      "cadastrarLancamentoCaixa",
      "listarPermissao",
      "setModalListarLancamentoCaixa",
      "setModalRelatorioFechamentoCaixa",
    ]),
    pesquisar() {
      this.listarLancamentoCaixa(this.dataPagina);
    },
  },
  created() {
    this.listarLancamentoCaixa({});
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>